/** Checkbox mit Label und optionalem Hinweis-Text. */
export function Checkbox({
    checked,
    onChange,
    label,
    hint,
    disabled = false,
}: {
    checked: boolean
    onChange: (checked: boolean) => void
    label: string
    hint?: string
    disabled?: boolean
}) {
    return (
        <label
            className={`flex cursor-pointer items-start gap-2 text-sm ${
                disabled ? 'cursor-not-allowed opacity-60' : ''
            }`}
        >
            <input
                type='checkbox'
                checked={checked}
                disabled={disabled}
                onChange={e => onChange(e.target.checked)}
                className='mt-0.5 h-4 w-4 rounded border-slate-300 accent-indigo-600 dark:border-slate-600'
            />
            <span>
                {label}
                {hint !== undefined && (
                    <span className='block text-xs text-slate-500 dark:text-slate-400'>
                        {hint}
                    </span>
                )}
            </span>
        </label>
    )
}
